import React, { Component } from "react";
import { hot } from "react-hot-loader";
import { connect } from "react-redux";
import {
    Typography,
    Button,
    Grid,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    IconButton,
    InputAdornment,
    Snackbar,
    FormControlLabel,
    Checkbox,
    SnackbarContent,
    Menu,
    List,
    ListItem,
    Input,
} from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import { StyledContent, StyledHeader } from "../../../styles";
import AddPersonIcon from "@material-ui/icons/PersonAdd";
import AddGroupIcon from "@material-ui/icons/GroupAdd";
import DeleteIcon from "@material-ui/icons/Delete";

import AddIcon from "@material-ui/icons/Add";
import {
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Spinner,
} from "reactstrap";

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import AddPhotoIcon from "@material-ui/icons/AddAPhoto";
import { noImg } from "vrcore-dashboard/dist/utilities";
import {
    setNewUser,
    getQualifications,
    setNewCrewUser,
    getUserTypes,
    submitNewUserTypes,
    removeUserType,
    submitNewArea,
    submitNewDepartment,
    getAreas,
    getDepartments,
    generateQualAlerts,
    getAllUsers
} from "./actions";
import moment from "moment";
import blankProfile from "./blankProfile.json";
import styled from "styled-components";
const InfoDiv = styled.div`
    display: inline-flex !important;
    margin-top: 30px;
`;

const LabelTypography = styled(Typography)`
    width: 150px !important;
`;

class AddUserWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addUserModal: false,
            newUserAuthed: true,
            deleteUserTypeModal: false,
            processModal: false,
            showPassword: false,
            password: "",
            user: { ...blankProfile, user_type: this.props.currentUserType },
            canSubmit: false,
            uploadImageLocal: false,
            imageMaxSize: false,
            newUserSuccess: false,
            newUserFail: false,
            newUserTypeSuccess: false,
            newUserTypeFail: false,
            user_type: {
                title: "",
                auth: true,
            },
            newArea: "",
            newDepartment: "",
            areaModal: false,
            departmentModal: false,
            anchorEl: null,
            userType_selected: "",
            alertSent: false,
            warningModal: false,
            warningMessgae: "",
            isModalOpen : false,
            targetReference: ""

        };
        props.getUserTypes();
        props.getDepartments();
        props.getAreas();
        props.getQualifications();
        props.getAllUsers();
    }
    // componentDidUpdate(prevProps,prevState){

    // }
    handleUserReset = () => {
        this.setState({
            password: "",
            canSubmit: false,
            uploadImageLocal: false,
            imageMaxSize: false,

            user: { ...blankProfile, user_type: this.props.currentUserType },
        });
    };

    handleNickNameReset = () => {
        this.setState({
            user: { ...this.state.user, nick_name: "" },
        });
    };
    

    handleUserTypeReset = () => {
        this.setState({
            user_type: {
                title: "",
                auth: true,
            },
        });
    };
    renderTextDetail = (key, label) => {
        const { user } = this.state;
        return (
            <TextField
                value={user[key]}
                label={label}
                style={{
                    border: "2px solid #0188cc",
                    borderRadius: "9px",

                    width: "100%",
                    padding: 12,
                }}
                onChange={(event) => {
                    if(key === "contact_no"){
                        if(/^0/.test(event.target.value)){
                            event.target.value = event.target.value.replace(/^0/, "")
                        }
                    }
                    if(key === "nick_name" && this.props.allNickNames.includes(
                        event.target.value.toLowerCase()
                    ) === true )
                    {
                        this.setState({ warningModal: true, warningMessgae: "Nick Name already exists!!" });
                        event.target.value = ""
                    }
                    let user = {
                        ...this.state.user,
                        [key]: event.target.value,
                    };
                    this.setState({ user });
                }}
            />
        );
    };
    renderTextDetailNickName = (key, label) => {

        const { user } = this.state;
        return (
            <TextField

                value={user[key]}
                label={label}
                style={{
                    border: "2px solid #0188cc",
                    borderRadius: "9px",

                    width: "100%",
                    padding: 12,
                }}
                onChange={(event) => {
                    if(key === "nick_name" && this.props.allNickNames.includes(
                        event.target.value.toLowerCase()
                    ) === true )
                    {
                        this.setState({ warningModal: true, warningMessgae: "Nick Name already exists!!" });
                        event.target.value = ""
                    }
                    let user = {
                        ...this.state.user,
                        [key]: event.target.value,
                    };
                    this.setState({ user });
                }}
            />
        );
    };
    renderDropdown = (key, label, opts) => {
        const { user } = this.state;
        return (
            <FormControl style={{ width: "100%", padding: 12 }}>
                <InputLabel>{label}</InputLabel>
                <Select
                    value={user[key]}
                    onChange={(event) => {
                        let user = {
                            ...this.state.user,
                            [key]: event.target.value,
                        };
                        this.setState({ user });
                    }}
                >
                    {opts.map((e) => {
                        return (
                            <MenuItem value={e} key={e}>
                                {e}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        );
    };

    renderDropdownAccessLevel = (key, label, opts) => {
        const { user } = this.state;
        return (
            <FormControl style={{ width: "100%", padding: 12 }}>
                <InputLabel>{label}</InputLabel>
                <Select
                    value= {user[key]}
                    onChange={(event) => {
                        let user = {
                            ...this.state.user,
                            [key]: event.target.value,
                        };
                        this.setState({ user });
                    }}
                >
                    {opts.map((e) => {
                        return (

                            <MenuItem value={e} key={e}>
                                {
                                    e === "Level 1" ? "User-Level 1" 
                                    : e === "Level 2" ? "User-Level 2"
                                    : e === "Level 3" ? "User-Level 3"
                                    : e === "Level 4" ? "User-Level 4"
                                    : e === "Level 0" ? "User-Level 0"
                                    : e === "Equipment" ? "Admin Equipment"
                                    : e === "User" ? "Admin User"
                                    : e === "Plant" ? "Admin Plant"
                                    : e === "Client" ? "Client"
                                    : e === "Contractor" ? "Contractor"
                                    : ""
                                }
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        );
    };
    
    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    canSubmit = () => {
        console.log(this.state.user.nick_name.includes("^"),"*****************")
        if (this.state.newUserAuthed) {
            if (
                this.state.password.length > 6 &&
                this.validateEmail(this.state.user.email) &&
                !this.props.user_emails.includes(this.state.user.email) &&
                this.state.user.first_name !== "" &&
                this.state.user.last_name !== "" &&
                this.state.user.email !== "" &&
                this.state.user.contact_no !== "" &&
                this.state.user.nick_name.length === 8 &&
                this.state.user.nick_name.includes(".") === false &&
                this.state.user.nick_name.includes("#") === false &&
                this.state.user.nick_name.includes("$") === false &&
                this.state.user.nick_name.includes("/") === false &&
                this.state.user.nick_name.includes("!") === false &&
                this.state.user.nick_name.includes("+") === false &&
                this.state.user.nick_name.includes("_") === false &&
                this.state.user.nick_name.includes("-") === false &&
                this.state.user.nick_name.includes("&") === false &&
                this.state.user.nick_name.includes("^") === false &&
                this.state.user.nick_name.includes("%") === false &&
                this.state.user.nick_name.includes("@") === false &&
                this.state.user.nick_name.includes("`") === false &&
                isNaN(this.state.user.nick_name) === true &&
                this.props.allNickNames.includes(this.state.user.nick_name) === false
            ) {
                return true;
            } else return false;
        } else {
            if (
                this.validateEmail(this.state.user.email) &&
                !this.props.user_emails.includes(this.state.user.email) &&
                this.state.user.first_name !== "" &&
                this.state.user.last_name !== "" &&
                this.state.user.email !== "" &&
                this.state.user.contact_no !== "" &&
                this.state.user.nick_name.length === 8 &&
                this.state.user.nick_name.includes(".") === false &&
                this.state.user.nick_name.includes("#") === false &&
                this.state.user.nick_name.includes("$") === false &&
                this.state.user.nick_name.includes("/") === false &&
                this.state.user.nick_name.includes("/") === false &&
                this.state.user.nick_name.includes("!") === false &&
                this.state.user.nick_name.includes("+") === false &&
                this.state.user.nick_name.includes("_") === false &&
                this.state.user.nick_name.includes("-") === false &&
                this.state.user.nick_name.includes("&") === false &&
                this.state.user.nick_name.includes("^") === false &&
                this.state.user.nick_name.includes("%") === false &&
                this.state.user.nick_name.includes("@") === false &&
                this.state.user.nick_name.includes("`") === false &&
                isNaN(this.state.user.nick_name) === true &&
                this.props.allNickNames.includes(this.state.user.nick_name) === false
            ) {
                return true;
            } else return false;
        }
    };
    renderUserDetails = () => {
        const { user_types, departments, areas } = this.props;

        const { user } = this.state;

        return (
            <Grid container spacing={2}>
                <Grid item md={12} xs={12}>
                    {/* <UserTypeDiv > */}
                    <img
                        style={{
                            height: 140,
                            width: 140,
                            marginLeft: "148px",
                            marginTop: 20,
                            marginBottom: "-8px",
                        }}
                        src={
                            this.state.uploadImageLocal
                                ? this.state.uploadImageLocal
                                : noImg
                        }
                        alt="Profile"
                    />
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <input
                            type="file"
                            id="file"
                            ref="imageUploader"
                            style={{ display: "none" }}
                            onChange={(event) => {
                                if (event.target.files[0].size > 1000000) {
                                    this.setState({
                                        imageMaxSize: true,
                                    });
                                } else {
                                    let user = {
                                        ...this.state.user,
                                        profile_image_url:
                                            event.target.files[0],
                                    };

                                    this.setState({
                                        user,
                                        uploadImageLocal: URL.createObjectURL(
                                            event.target.files[0]
                                        ),
                                    });
                                }
                            }}
                        />
                        <IconButton
                            style={{
                                color: "indigo",
                                border: "1px solid indigo",
                                marginLeft: "110px",
                            }}
                            onClick={() => {
                                this.refs.imageUploader.click();
                            }}
                        >
                            <AddPhotoIcon />
                        </IconButton>
                        <Typography
                            style={{ marginRight: "92px", marginTop: "14px" }}
                            variant="body1"
                        >
                            Add Profile Picture {`(<1MB)`}
                        </Typography>
                    </div>
                </Grid>
                <Grid item md={12} xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.state.newUserAuthed}
                                onChange={(event) => {
                                    this.setState({
                                        newUserAuthed: event.target.checked,
                                        canSubmit: this.state.newUserAuthed,
                                    });
                                }}
                                value="Authenticated"
                                color="primary"
                            />
                        }
                        label="Allow log-in access?"
                    />
                </Grid>
                <Grid item md={12} xs={12}>
                    {this.renderTextDetailNickName("nick_name", "Nick Name")}
                </Grid>
                <FormHelperText style={{ color: "red", marginLeft:"33px" }}>
                    Nick Name/Report Identifier should contain only 8 characters combination of letters and numbers only (no special characters)
                </FormHelperText>
                <Grid item md={6} xs={12}>
                    {this.renderTextDetail("first_name", "First Name")}
                </Grid>
                <Grid item md={6} xs={12}>
                    {this.renderTextDetail("last_name", "Last Name")}
                </Grid>
                <Grid item md={12} xs={12}>
                    {this.renderTextDetail("email", "Email Address")}
                </Grid>
                <Grid item md={3} xs={12}>
                    {this.renderDropdown("no_prefix", "Prefix", [
                        "+353",
                        "+44",
                    ])}
                </Grid>
                <Grid item md={9} xs={12}>
                    {this.renderTextDetail("contact_no", "Contact Number")}
                </Grid>

                {user_types && (
                    <Grid item md={12} xs={12}>
                        <FormControl
                            style={{
                                width: "100%",
                                border: "2px solid #0188cc",
                                borderRadius: "9px",
                                padding: 12,
                            }}
                        >
                            <InputLabel>User Type</InputLabel>
                            <Select
                                value={user["user_type"]}
                                onChange={(event) => {
                                    let user = {
                                        ...this.state.user,
                                        user_type: event.target.value,
                                    };
                                    this.handleUserReset();
                                    this.setState({
                                        user,
                                    });
                                }}
                            >
                                {user_types &&
                                    Object.keys(user_types).map((e) => {
                                        return (
                                            <MenuItem key={e} value={e}>
                                                {user_types[e].title}
                                            </MenuItem>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                    </Grid>
                )}
                {this.state.newUserAuthed && (
                    <React.Fragment>
                        <Grid item md={12} xs={12}>
                            <FormControl
                                style={{
                                    width: "100%",
                                    border: "2px solid #0188cc",
                                    borderRadius: "9px",
                                    padding: 12,
                                }}
                            >
                                <InputLabel htmlFor="adornment-password">
                                    &nbsp;&nbsp;Password
                                </InputLabel>
                                <Input
                                    autoComplete="off"
                                    id="adornment-password"
                                    type={
                                        this.state.showPassword
                                            ? "text"
                                            : "password"
                                    }
                                    value={this.state.password}
                                    onChange={(event) => {
                                        this.setState({
                                            password: event.target.value,
                                        });
                                    }}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="Toggle password visibility"
                                                style={{ float: "right" }}
                                                onClick={() => {
                                                    this.setState({
                                                        showPassword: !this
                                                            .state.showPassword,
                                                    });
                                                }}
                                            >
                                                {this.state.showPassword ? (
                                                    <Visibility />
                                                ) : (
                                                    <VisibilityOff />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />

                                <FormHelperText style={{ color: "black" }}>
                                    Password must contain at least 7 digits
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item md={12} xs={12}>
                            {this.state.user.user_type !== "crew" && (
                                <React.Fragment>
                                    <div
                                        style={{
                                            border: "2px solid #0188cc",
                                            borderRadius: "9px",
                                        }}
                                    >
                                        {this.renderDropdownAccessLevel(
                                            "access_level",
                                            "Access Level",
                                            [
                                                "Level 0",
                                                "Level 1",
                                                "Level 2",
                                                "Level 3",
                                                "Level 4",
                                                "Equipment",
                                                "User",
                                                "Plant",
                                                "Client",
                                                "Contractor",
                                            ]
                                        )}
                                    </div>
                                    <br />
                                    <div
                                        style={{
                                            border: "2px solid #0188cc",
                                            borderRadius: "9px",
                                        }}
                                    >
                                        {this.renderDropdown(
                                            "security_level",
                                            "Security Level",
                                            ["User", "Admin"]
                                        )}
                                    </div>
                                </React.Fragment>
                            )}
                        </Grid>
                    </React.Fragment>
                )}
                <Grid item md={12} xs={12}>
                    <FormControl
                        style={{
                            width: "100%",
                            border: "2px solid #0188cc",
                            borderRadius: "9px",
                            padding: 12,
                        }}
                    >
                        <InputLabel>Departments</InputLabel>
                        <Select
                            multiple
                            value={user["departments"]}
                            onChange={(event) => {
                                let us = user;
                                us["departments"] = event.target.value;
                                this.setState({ user: us });
                            }}
                        >
                            {departments &&
                                Object.keys(departments).map((e) => {
                                    return (
                                        <MenuItem
                                            key={e}
                                            value={departments[e]}
                                        >
                                            {departments[e]}
                                        </MenuItem>
                                    );
                                })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item md={12} xs={12}>
                    <FormControl
                        style={{
                            width: "100%",
                            border: "2px solid #0188cc",
                            borderRadius: "9px",
                            padding: 12,
                        }}
                    >
                        <InputLabel>Areas</InputLabel>
                        <Select
                            multiple
                            value={user["areas"]}
                            onChange={(event) => {
                                let us = user;
                                us["areas"] = event.target.value;
                                this.setState({ user: us });
                            }}
                        >
                            {areas &&
                                Object.keys(areas).map((e) => {
                                    return (
                                        <MenuItem key={e} value={areas[e]}>
                                            {areas[e]}
                                        </MenuItem>
                                    );
                                })}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        );
    };
    handleClick = (event) => {
        let reference = this.state.targetReference
        this.setState({ anchorEl: reference, isModalOpen: false });
    };
    handleClick1 = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };
    handleUserSubmit = () => {
        const { qualifications } = this.props;
        const { user, password } = this.state;
        let date = moment().format("DD-MM-YYYY HH:mm:ss");
        user.account_created = date;
        user.last_active = "N/A";
        user.last_active_dashboard = "N/A";
        user.contact_no = user.no_prefix + user.contact_no;
        delete user.no_prefix;

        let quals = {};
        if (qualifications) {
            Object.keys(qualifications).map((e) => {
                quals[e] = {
                    qualification_category:
                        qualifications[e].qualification_category,
                    qualification_desc: qualifications[e].qualification_desc,
                    qualification_exp_date:
                        qualifications[e].expiry_date_required === true
                            ? "Req."
                            : "N/A",
                    qualification_id: qualifications[e].qualification_id,
                    qualification_img:
                        qualifications[e].qualification_image_required === true
                            ? ""
                            : "N/A",
                    qualification_invalid_img:
                        qualifications[e].qualification_invalid_img,
                    qualification_prefix:
                        qualifications[e].qualification_prefix,
                    qualification_reg_num:
                        qualifications[e].reg_number_required === true
                            ? ""
                            : "N/A",
                    qualification_title: qualifications[e].qualification_title,
                    qualification_valid_img:
                        qualifications[e].qualification_valid_img,
                    qualification_verified:
                        qualifications[e]
                            .qualification_verification_required === true
                            ? "No"
                            : "N/A",
                };
                return true;
            });
        }
        user.qualifications_per_user = quals;
        if (this.state.newUserAuthed) {
            this.props.setNewUser(
                user,
                password,
                this.props.user_emails,
                (success) => {
                    if (success) {
                        this.setState({ processModal: false });
                        this.setState({ newUserSuccess: true });
                    } else {
                        this.setState({ newUserFail: true });
                    }
                }
            );
        } else {
            this.props.setNewCrewUser(
                user,
                this.props.user_emails,
                (success) => {
                    if (success) {
                        this.setState({ newUserSuccess: true });
                        this.setState({ processModal: false });
                    } else {
                        this.setState({ newUserFail: true });
                    }
                }
            );
        }

        this.setState({ addUserModal: false });
        this.handleUserReset();
    };
    handleClose = () => {
        this.setState({ anchorEl: null });
    };
    checkDuplicateUserType = () => {
        return this.props.userTypes.includes(
            this.state.user_type.title.toLowerCase()
        );
    };
    render() {
        const { user_type, anchorEl } = this.state;
        const { userTypes, qualsPerCategoryAllUser } = this.props;
        return (
            <React.Fragment>
                <div style={{ float: "right" }}>
                    <Button
                        color="primary"
                        variant="contained"
                        style={{ background: "#0188cc" }}
                        onClick={() => {
                            this.props.generateQualAlerts(
                                qualsPerCategoryAllUser
                            );
                            this.setState({ alertSent: true });
                        }}
                    >
                        Generate Qualification Alerts
                    </Button>
                    &nbsp;&nbsp;
                    <Snackbar
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                        }}
                        autoHideDuration={6000}
                        open={this.state.alertSent}
                        onClose={() => {
                            this.setState({ alertSent: false });
                        }}
                    >
                        <SnackbarContent
                            style={{ backgroundColor: "green", color: "white" }}
                            message="Alerts has been generated, please check in Alerts section"
                        />
                    </Snackbar>
                    {this.props.canCreate && (
                        <>
                            <Button
                                variant="contained"
                                color="primary"
                                aria-owns={anchorEl ? "simple-menu" : undefined}
                                aria-haspopup="true"
                                onClick={this.handleClick1}
                                style={{ borderRadius: 500, background: "#0188cc" }}
                            >
                                <AddIcon />
                            </Button>
                        </>
                    )}
                    {!this.props.canCreate && (
                        <>
                            <Button
                                variant="contained"
                                color="primary"
                                aria-owns={anchorEl ? "simple-menu" : undefined}
                                aria-haspopup="true"
                                // onClick={this.handleClick}
                                onClick={(event) => {
                                    this.setState({ isModalOpen: true, targetReference: event.currentTarget })
                                }
                                }
                                style={{ borderRadius: 500, background: "#0188cc" }}
                            >
                                <AddIcon />
                            </Button>
                        </>
                    )}
                    

                    <Modal isOpen={this.state.isModalOpen}>
                        <ModalHeader>Warning!!!</ModalHeader>
                        <ModalBody>
                            {this.props.canCreate && this.props.canDelete &&(
                                <>
                                 <b style={{color:"green"}}>
                                    - You Have correct Permissions to perform <br/>
                                    &nbsp;&nbsp; Add User <br/>
                                    &nbsp;&nbsp; Add User Type <br/>
                                    &nbsp;&nbsp; Add Department <br/>
                                    &nbsp;&nbsp; Add Area <br/>
                                    &nbsp;&nbsp; Delete User type
                                </b>
                                </>
                            )}
                            {!this.props.canCreate && !this.props.canDelete &&(
                                <>
                                <b style={{color:"red"}}>
                                    - You do not have the correct permissions to perform <br/>
                                    &nbsp;&nbsp; Add User <br/>
                                    &nbsp;&nbsp; Add User Type <br/>
                                    &nbsp;&nbsp; Add Department <br/>
                                    &nbsp;&nbsp; Add Area <br/>
                                    &nbsp;&nbsp; Delete User type
                                    <br/>
                                    for permissions Please Contact your Office Administrator 
                                </b>
                                </>
                            )}
                            {this.props.canCreate === false && this.props.canDelete === true &&(
                                <>
                                 <b style={{color:"green"}}>
                                    - You Have correct Permissions to perform <br/>
                                    &nbsp;&nbsp; Delete User type
                                </b>
                                <br/>
                                <br/>
                                <b style={{color:"red"}}>
                                    - You do not have the correct permissions to perform <br/>
                                    &nbsp;&nbsp; Add User <br/>
                                    &nbsp;&nbsp; Add User Type <br/>
                                    &nbsp;&nbsp; Add Department <br/>
                                    &nbsp;&nbsp; Add Area <br/>
                                    <br/>
                                    for permissions Please Contact your Office Administrator 
                                </b>
                                </>
                            )}
                            {this.props.canDelete === false && this.props.canCreate === true &&(
                                <>
                                 <b style={{color:"green"}}>
                                    - You Have correct Permissions to perform <br/>
                                    &nbsp;&nbsp; Add User <br/>
                                    &nbsp;&nbsp; Add User Type <br/>
                                    &nbsp;&nbsp; Add Department <br/>
                                    &nbsp;&nbsp; Add Area 
                                </b>
                                <br/>
                                <br/>
                                <b style={{color:"red"}}>
                                    - You do not have the correct permissions to perform <br/>
                                    &nbsp;&nbsp; Delete User type<br/>
                                    <br/>
                                    for permissions Please Contact your Office Administrator 
                                </b>
                                </>
                            )}
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                onClick={this.handleClick}
                            >
                                Cancel
                            </Button>
                        </ModalFooter>
                    </Modal>
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={this.handleClose}
                    >
                        {this.props.canCreate && (
                            <MenuItem
                                onClick={() => {
                                    this.handleUserReset();
                                    this.setState({ addUserModal: true });
                                    this.handleClose();
                                }}
                            >
                                <AddPersonIcon />
                                <Typography
                                    style={{ marginLeft: 15 }}
                                    variant="h6"
                                >
                                    Add New User
                                </Typography>
                            </MenuItem>
                        )}
                        {this.props.canCreate && (
                            <MenuItem
                                onClick={() => {
                                    this.handleUserReset();
                                    this.setState({
                                        addUserTypeModal: true,
                                    });

                                    this.handleClose();
                                }}
                            >
                                <AddGroupIcon />
                                <Typography
                                    style={{
                                        marginLeft: 15,
                                    }}
                                    variant="h6"
                                >
                                    Add New User Type
                                </Typography>
                            </MenuItem>
                        )}
                        {this.props.canDelete && (
                            <MenuItem
                                onClick={() => {
                                    this.handleUserReset();
                                    this.setState({
                                        deleteUserTypeModal: true,
                                    });
                                    this.handleClose();
                                }}
                            >
                                <DeleteIcon />
                                <Typography
                                    style={{
                                        marginLeft: 15,
                                    }}
                                    variant="h6"
                                >
                                    Delete User Type
                                </Typography>
                            </MenuItem>
                        )}
                        {this.props.canCreate && (
                            <MenuItem
                                onClick={() => {
                                    this.setState({
                                        departmentModal: true,
                                    });
                                    this.handleClose();
                                }}
                            >
                                <AddIcon />
                                <Typography
                                    style={{
                                        marginLeft: 15,
                                    }}
                                    variant="h6"
                                >
                                    Add Department
                                </Typography>
                            </MenuItem>
                        )}
                        {this.props.canCreate && (
                            <MenuItem
                                onClick={() => {
                                    this.setState({
                                        areaModal: true,
                                    });
                                    this.handleClose();
                                }}
                            >
                                <AddIcon />
                                <Typography
                                    style={{
                                        marginLeft: 15,
                                    }}
                                    variant="h6"
                                >
                                    Add Area
                                </Typography>
                            </MenuItem>
                        )}
                    </Menu>

                </div>
                <Modal isOpen={this.state.deleteUserTypeModal}>
                    <StyledHeader>
                        <Typography variant="h5">Remove User Type</Typography>
                    </StyledHeader>
                    <StyledContent>
                        <ModalBody>
                            <Typography variant="body2">
                                Make Sure to swap all the users before deleting
                                the user type <br />
                            </Typography>
                            <InfoDiv>
                                <LabelTypography variant="h6" for="usertype">
                                    User Type:
                                </LabelTypography>
                                <Select
                                    id="usertype"
                                    style={{ width: "150px" }}
                                    value={this.state.userType_selected}
                                    onChange={(event) => {
                                        this.setState({
                                            userType_selected:
                                                event.target.value,
                                        });
                                    }}
                                >
                                    {userTypes &&
                                        userTypes.map((e, i) => {
                                            return (
                                                <MenuItem key={i} value={e}>
                                                    {e}
                                                </MenuItem>
                                            );
                                        })}
                                </Select>
                            </InfoDiv>
                        </ModalBody>
                    </StyledContent>
                    <ModalFooter>
                        <div>
                            <Button
                                onClick={() => {
                                    this.setState({
                                        deleteUserTypeModal: false,
                                        userType_selected: "",
                                    });
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.props.refreshTab();
                                    this.props.removeUserType(
                                        this.state.userType_selected
                                    );
                                    this.setState({
                                        deleteUserTypeModal: false,
                                        userType_selected: "",
                                    });
                                }}
                            >
                                Remove
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.addUserModal}>
                    <StyledHeader>
                        <Typography variant="h5">
                            Add New User Details
                        </Typography>
                    </StyledHeader>
                    <StyledContent>
                        <ModalBody>{this.renderUserDetails()}</ModalBody>
                    </StyledContent>
                    <ModalFooter>
                        <Button
                            onClick={() => {
                                
                                this.handleUserReset();
                                this.setState({ canSubmit: false });
                            }}
                        >
                            Reset
                        </Button>
                        <Button
                            onClick={() => {
                                this.handleUserReset();
                                this.setState({
                                    addUserModal: false,
                                    canSubmit: false,
                                });
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            // disabled={this.canSubmit() === false}
                            onClick={() => {
                                let userName = this.state.user.first_name + " " + this.state.user.last_name
                                if(this.props.allNames.includes(userName) === true)
                                {
                                    this.setState({ warningModal: true, warningMessgae:`${userName} Name already exists in the system please update the name!!` });
                                }
                                else if(this.state.newUserAuthed && this.state.password.length < 6){
                                    this.setState({ warningModal: true, warningMessgae:`Password Length should be greater then 6!!` });
                                }
                                else if(this.state.newUserAuthed && !this.validateEmail(this.state.user.email)){
                                    this.setState({ warningModal: true, warningMessgae:`Entered Email is invalid please update!!` });
                                }
                                else if(this.state.newUserAuthed && this.props.user_emails.includes(this.state.user.email)){
                                    this.setState({ warningModal: true, warningMessgae:`Email already exists in the system please update the EmailID!!` });
                                }
                                else if(this.state.newUserAuthed && this.state.user.first_name === ""){
                                    this.setState({ warningModal: true, warningMessgae:`User first name should not be blank!!` });
                                }
                                else if(this.state.newUserAuthed && this.state.user.last_name === ""){
                                    this.setState({ warningModal: true, warningMessgae:`User last name should not be blank!!!!` });
                                }
                                else if(this.state.newUserAuthed && this.state.user.email === ""){
                                    this.setState({ warningModal: true, warningMessgae:`User email should not be blank!!!!` });
                                }
                                else if(this.state.newUserAuthed && this.state.user.contact_no === ""){
                                    this.setState({ warningModal: true, warningMessgae:`User contact number should not be blank!!!!` });
                                }
                                else if(this.state.newUserAuthed && this.state.user.nick_name.length !== 8){
                                    this.setState({ warningModal: true, warningMessgae:`Nick name should contain only 8 characters!!` });
                                }
                                else if(this.state.newUserAuthed && this.state.user.nick_name.includes(".") === true){
                                    this.setState({ warningModal: true, warningMessgae:`Nick name should not include special characters like .!!` });
                                }
                                else if(this.state.newUserAuthed && this.state.user.nick_name.includes("#") === true){
                                    this.setState({ warningModal: true, warningMessgae:`Nick name should not include special characters like #!!` });
                                }
                                else if(this.state.newUserAuthed && this.state.user.nick_name.includes("$") === true){
                                    this.setState({ warningModal: true, warningMessgae:`Nick name should not include special characters like $!!` });
                                }
                                else if(this.state.newUserAuthed && this.state.user.nick_name.includes("/") === true){
                                    this.setState({ warningModal: true, warningMessgae:`Nick name should not include special characters like /!!` });
                                }
                                else if(this.state.newUserAuthed && isNaN(this.state.user.nick_name) === false){
                                    this.setState({ warningModal: true, warningMessgae:`Nick name should not include only numbers!!` });
                                }
                                else if(this.state.newUserAuthed && this.props.allNickNames.includes(this.state.user.nick_name) === true){
                                    this.setState({ warningModal: true, warningMessgae:`Nick Name already exists in the system please update the Nick Name!!!` });
                                }

                                else if(!this.state.newUserAuthed && !this.validateEmail(this.state.user.email)){
                                    this.setState({ warningModal: true, warningMessgae:`Entered Email is invalid please update!!` });
                                }
                                else if(!this.state.newUserAuthed && this.props.user_emails.includes(this.state.user.email)){
                                    this.setState({ warningModal: true, warningMessgae:`Email already exists in the system please update the EmailID!!` });
                                }
                                else if(!this.state.newUserAuthed && this.state.user.first_name === ""){
                                    this.setState({ warningModal: true, warningMessgae:`User first name should not be blank!!` });
                                }
                                else if(!this.state.newUserAuthed && this.state.user.last_name === ""){
                                    this.setState({ warningModal: true, warningMessgae:`User last name should not be blank!!!!` });
                                }
                                else if(!this.state.newUserAuthed && this.state.user.email === ""){
                                    this.setState({ warningModal: true, warningMessgae:`User email should not be blank!!!!` });
                                }
                                else if(!this.state.newUserAuthed && this.state.user.contact_no === ""){
                                    this.setState({ warningModal: true, warningMessgae:`User contact number should not be blank!!!!` });
                                }
                                else if(!this.state.newUserAuthed && this.state.user.nick_name.length !== 8){
                                    this.setState({ warningModal: true, warningMessgae:`Nick name should contain only 8 characters!!` });
                                }
                                else if(!this.state.newUserAuthed && this.state.user.nick_name.includes(".") === true){
                                    this.setState({ warningModal: true, warningMessgae:`Nick name should not include special characters like .!!` });
                                }
                                else if(!this.state.newUserAuthed && this.state.user.nick_name.includes("#") === true){
                                    this.setState({ warningModal: true, warningMessgae:`Nick name should not include special characters like #!!` });
                                }
                                else if(!this.state.newUserAuthed && this.state.user.nick_name.includes("$") === true){
                                    this.setState({ warningModal: true, warningMessgae:`Nick name should not include special characters like $!!` });
                                }
                                else if(!this.state.newUserAuthed && this.state.user.nick_name.includes("/") === true){
                                    this.setState({ warningModal: true, warningMessgae:`Nick name should not include special characters like /!!` });
                                }
                                else if(!this.state.newUserAuthed && isNaN(this.state.user.nick_name) === false){
                                    this.setState({ warningModal: true, warningMessgae:`Nick name should not include only numbers!!` });
                                }
                                else if(!this.state.newUserAuthed && this.props.allNickNames.includes(this.state.user.nick_name) === true){
                                    this.setState({ warningModal: true, warningMessgae:`Nick Name already exists in the system please update the Nick Name!!!` });
                                }
                                else{
                                    this.handleUserSubmit();
                                    this.setState({ processModal: true });
                                }
                            }}
                            variant="contained"
                            color="primary"
                            style={{
                                backgroundColor: "#0188cc",
                                    // this.canSubmit() === true
                                    //     ? "#0188cc"
                                    //     : "#eee",
                                color: "white",
                            }}
                        >
                            Submit
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal
                    isOpen={this.props.requesting}
                    style={{ maxWidth: "00px" }}
                >
                    <ModalBody>
                        <div style={{ textAlign: "center", paddingTop: "3em" }}>
                            <div
                                style={{
                                    background: "white",
                                    width: "fit-content",
                                    display: "inline-block",
                                    padding: "2em",
                                }}
                            >
                                <Spinner
                                    style={{
                                        height: 100,
                                        width: 100,
                                        background: "white",
                                        color: "#0188cc",
                                    }}
                                    color="primary"
                                />
                                <Typography
                                    style={{
                                        textAlign: "center",
                                        marginTop: 15,
                                        color: "rgba(0, 0, 0, 0.87)",
                                        fontWeight: "bolder",
                                        fontSize: 20,
                                    }}
                                    variant="body2"
                                >
                                    Processing...
                                </Typography>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.addUserTypeModal}>
                    {/* <ModalHeader>Add New User Type</ModalHeader> */}
                    <StyledHeader>
                        <Typography variant="h5">Add New User Type</Typography>
                    </StyledHeader>
                    <StyledContent>
                        <ModalBody>
                            <TextField
                                value={user_type.title}
                                label={"User Type Title"}
                                onChange={(event) => {
                                    let type = this.state.user_type;
                                    type.title = event.target.value;
                                    this.setState({ user_type: type });
                                    if (
                                        this.props.userTypes.includes(
                                            this.state.user_type.title.toLowerCase()
                                        ) === true
                                    ) {
                                        this.setState({ warningModal: true, warningMessgae : "This user type already exists" });
                                    }
                                }}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={user_type.auth}
                                        onChange={(event) => {
                                            let type = this.state.user_type;
                                            type.auth = event.target.checked;
                                            this.setState({ user_type: type });
                                        }}
                                        value="Is authenticated?"
                                        color="primary"
                                    />
                                }
                                label="Is authenticated?"
                            />
                            <br />
                            <b>Note:</b>If you do not select ‘'is
                            authenticated’' the users added to this user type
                            will not be able to log into the system, and will
                            only be available to add to staff lists.
                        </ModalBody>
                    </StyledContent>
                    <ModalFooter>
                        <Button
                            onClick={() => {
                                this.setState({
                                    addUserTypeModal: false,
                                });
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={
                                this.state.user_type.title === "" ||
                                this.checkDuplicateUserType()
                            }
                            onClick={() => {
                                this.props.submitNewUserTypes(
                                    this.state.user_type,
                                    (success) => {
                                        success
                                            ? this.setState({
                                                  newUserTypeSuccess: true,
                                              })
                                            : this.setState({
                                                  newUserTypeFail: true,
                                              });
                                    }
                                );
                                this.setState({
                                    addUserTypeModal: false,
                                });
                                this.handleUserTypeReset();
                            }}
                            variant="contained"
                            color="primary"
                            style={{ background: "#0188cc" }}
                        >
                            Submit
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.departmentModal}>
                    {/* <ModalHeader>Add New User Type</ModalHeader> */}
                    <StyledHeader>
                        <Typography variant="h5">Add New Department</Typography>
                    </StyledHeader>
                    <StyledContent>
                        <ModalBody>
                            <TextField
                                value={this.state.newDepartment}
                                label={"Department Name"}
                                onChange={(event) => {
                                    this.setState({
                                        newDepartment: event.target.value,
                                    });
                                }}
                            />
                            <Typography variant="h6" style={{ marginTop: 24 }}>
                                Registered Departments
                            </Typography>
                            <List style={{ width: "100%" }}>
                                {this.props.departments &&
                                    Object.keys(this.props.departments).map(
                                        (e) => {
                                            return (
                                                <ListItem
                                                    style={{
                                                        margin: 4,
                                                        borderLeft:
                                                            "2px solid #ddd",
                                                        width: "100%",
                                                    }}
                                                >
                                                    {this.props.departments[e]}
                                                </ListItem>
                                            );
                                        }
                                    )}
                            </List>
                        </ModalBody>
                    </StyledContent>
                    <ModalFooter>
                        <Button
                            onClick={() => {
                                this.setState({
                                    departmentModal: false,
                                });
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={this.state.newDepartment === ""}
                            onClick={() => {
                                this.props.submitNewDepartment(
                                    this.state.newDepartment,
                                    (success) => {
                                        success
                                            ? this.setState({
                                                  newDepartmentSuccess: true,
                                              })
                                            : this.setState({
                                                  newDepartmentFail: true,
                                              });
                                    }
                                );
                                this.setState({
                                    departmentModal: false,
                                });
                            }}
                            variant="contained"
                            color="primary"
                            style={{ background: "#0188cc" }}
                        >
                            Submit
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.warningModal}>
                    <ModalHeader>Warning!!!</ModalHeader>
                    <ModalBody>
                        <b style={{color:"red"}}>{this.state.warningMessgae}</b>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            onClick={() => {
                                this.setState({
                                    warningModal: false,
                                    warningMessgae: ""
                                });
                            }}
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.areaModal}>
                    {/* <ModalHeader>Add New User Type</ModalHeader> */}
                    <StyledHeader>
                        <Typography variant="h5">Add New Area</Typography>
                    </StyledHeader>
                    <StyledContent>
                        <ModalBody>
                            <TextField
                                value={this.state.newArea}
                                label={"Area Name"}
                                onChange={(event) => {
                                    this.setState({
                                        newArea: event.target.value,
                                    });
                                }}
                            />
                            <Typography variant="h6" style={{ marginTop: 24 }}>
                                Registered Areas
                            </Typography>
                            <List style={{ width: "100%" }}>
                                {this.props.areas &&
                                    Object.keys(this.props.areas).map((e) => {
                                        return (
                                            <ListItem
                                                style={{
                                                    margin: 4,
                                                    borderLeft:
                                                        "2px solid #ddd",
                                                    width: "100%",
                                                }}
                                            >
                                                {this.props.areas[e]}
                                            </ListItem>
                                        );
                                    })}
                            </List>
                        </ModalBody>
                    </StyledContent>
                    <ModalFooter>
                        <Button
                            onClick={() => {
                                this.setState({
                                    areaModal: false,
                                });
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={this.state.newArea === ""}
                            onClick={() => {
                                this.props.submitNewArea(
                                    this.state.newArea,
                                    (success) => {
                                        success
                                            ? this.setState({
                                                  newAreaSuccess: true,
                                              })
                                            : this.setState({
                                                  newAreaFail: true,
                                              });
                                    }
                                );
                                this.setState({
                                    areaModal: false,
                                });
                            }}
                            variant="contained"
                            color="primary"
                            style={{ backgroundColor: "#0188cc" }}
                        >
                            Submit
                        </Button>
                    </ModalFooter>
                </Modal>
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    autoHideDuration={6000}
                    open={this.state.imageMaxSize}
                    onClose={() => {
                        this.setState({ imageMaxSize: false });
                    }}
                >
                    <SnackbarContent
                        style={{
                            backgroundColor: "red",
                            color: "white",
                        }}
                        message="Image Size Too Large, Please Choose an Image Under 1MB"
                    />
                </Snackbar>
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    autoHideDuration={6000}
                    open={
                        this.state.newDepartmentFail ||
                        this.state.newDepartmentSuccess
                    }
                    onClose={() => {
                        this.setState({
                            newDepartmentFail: false,
                            newDepartmentSuccess: false,
                        });
                    }}
                >
                    <SnackbarContent
                        style={{
                            backgroundColor: this.state.newDepartmentSuccess
                                ? "green"
                                : this.state.newDepartmentFail
                                ? "red"
                                : "white",
                            color: "white",
                        }}
                        message={
                            this.state.newDepartmentSuccess
                                ? "New Department Successfully Added !"
                                : this.state.newDepartmentFail
                                ? "Unable to Add Department, Please Contact Admin"
                                : ""
                        }
                    />
                </Snackbar>
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    autoHideDuration={6000}
                    open={this.state.newAreaFail || this.state.newAreaSuccess}
                    onClose={() => {
                        this.setState({
                            newAreaFail: false,
                            newAreaSuccess: false,
                        });
                    }}
                >
                    <SnackbarContent
                        style={{
                            backgroundColor: this.state.newAreaSuccess
                                ? "green"
                                : this.state.newAreaFail
                                ? "red"
                                : "white",
                            color: "white",
                        }}
                        message={
                            this.state.newAreaSuccess
                                ? "New Area Successfully Added !"
                                : this.state.newAreaFail
                                ? "Unable to Add Area, Please Contact Admin"
                                : ""
                        }
                    />
                </Snackbar>
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    autoHideDuration={6000}
                    open={this.state.newUserFail || this.state.newUserSuccess}
                    onClose={() => {
                        this.setState({
                            newUserFail: false,
                            newUserSuccess: false,
                        });
                    }}
                >
                    <SnackbarContent
                        style={{
                            backgroundColor: this.state.newUserSuccess
                                ? "green"
                                : this.state.newUserFail
                                ? "red"
                                : "white",
                            color: "white",
                        }}
                        message={
                            this.state.newUserSuccess
                                ? "New User Successfully Added !"
                                : this.state.newUserFail
                                ? "Unable Add User, Please Contact Admin"
                                : ""
                        }
                    />
                </Snackbar>
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    autoHideDuration={6000}
                    open={
                        this.state.newUserTypeFail ||
                        this.state.newUserTypeSuccess
                    }
                    onClose={() => {
                        this.setState({
                            newUserTypeFail: false,
                            newUserTypeSuccess: false,
                        });
                    }}
                >
                    <SnackbarContent
                        style={{
                            backgroundColor: this.state.newUserTypeSuccess
                                ? "green"
                                : this.state.newUserTypeFail
                                ? "red"
                                : "white",
                            color: "white",
                        }}
                        message={
                            this.state.newUserTypeSuccess
                                ? "New User Type Successfully Added !"
                                : this.state.newUserTypeFail
                                ? "Unable Add User Type, Please Contact Admin"
                                : ""
                        }
                    />
                </Snackbar>
            </React.Fragment>
        );
    }
}

export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;

            const {
                selectQualifications,
                selectUserTypes,
                selectAllUserTypes,
                selectAreas,
                selectDepartments,
                selectQualificationsPerCategoryAllUser,
                selectAllUserEmails,
                selectRequesting,
                selectAllNickNames,
                selectAllUserNames
            } = selectors;
            return {
                user_emails: selectAllUserEmails(store),
                qualifications: selectQualifications(store),
                user_types: selectUserTypes(store),
                userTypes: selectAllUserTypes(store),
                areas: selectAreas(store),
                departments: selectDepartments(store),
                requesting: selectRequesting(store),
                qualsPerCategoryAllUser: selectQualificationsPerCategoryAllUser(
                    store
                ),
                allNickNames: selectAllNickNames(store),
                allNames: selectAllUserNames(store)
            };
        },
        {
            setNewUser,
            getQualifications,
            setNewCrewUser,
            getUserTypes,
            submitNewUserTypes,
            removeUserType,
            submitNewArea,
            submitNewDepartment,
            getAreas,
            getDepartments,
            generateQualAlerts,
            getAllUsers
        }
    )(AddUserWidget)
);